import { useState, useEffect } from 'react'
import { apiService } from '../../../../services/api'
import { TimelineEntry } from '../../../../components/ui'

export const useLeadHistory = (leadId?: string) => {
  const [history, setHistory] = useState<TimelineEntry[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!leadId) {
      setHistory([])
      return
    }

    const fetchHistory = async () => {
      setIsLoading(true)
      setError(null)

      try {
        const response = await apiService.getLeadHistory(leadId)

        // Transform backend response to TimelineEntry format
        const entries: TimelineEntry[] = response.map((item: any) => ({
          id: item.id,
          type: item.type,
          userName: item.user?.name,
          userEmail: item.user?.email,
          timestamp: item.createdAt,
          fromStatus: item.fromStatus,
          toStatus: item.toStatus,
          fromFunnelStageId: item.fromFunnelStageId,
          toFunnelStageId: item.toFunnelStageId,
          contactChannel: item.contactChannel,
          contactTarget: item.contactTarget,
          metadata: item.metadata,
        }))

        setHistory(entries)
      } catch (err: any) {
        console.error('Erro ao carregar histórico do lead:', err)
        setError(err.message || 'Erro ao carregar histórico')
      } finally {
        setIsLoading(false)
      }
    }

    fetchHistory()
  }, [leadId])

  return { history, isLoading, error }
}
